<template>
  <div class="main_style">
    <Main_nav />
    <searchBar
      :knowledge="this.$route.query.knowledges_id"
      :community="this.$route.query.community_id"
      :category="this.$route.query.categories_id"
      :keyword="this.$route.query.keyword"
    />
    <b-row class="mt-5 ml-5 text-left">
      <b-col>
        <span style="font-size: 24px; font-weight: bolder">รายการค้นหา </span
        ><small class="ml-2"
          >ผลการค้นหาทั้งหมด {{ total_item_list }} รายการ</small
        >
      </b-col>
    </b-row>
    <b-row class="mx-5 my-3 text-left">
      <b-col cols="12" md="2">รูปภาพ</b-col>
      <b-col cols="12" md="2">ชื่อพืช</b-col>
      <b-col cols="12" md="2">ชื่อท้องถิ่น</b-col>
      <b-col cols="12" md="2">กลุ่มชนิดพืช</b-col>
      <b-col cols="12" md="2">ภูมิปัญญา</b-col>
    </b-row>
    <!--    TODO Loop data result Search-->
    <div v-if="plantList.length > 0">
      <b-card
        v-for="item in plantList"
        :key="item.id"
        @click="getDetail(item.view_plant_id)"
        class="mx-5 my-3 pointer shadow card-result text-left"
      >
        <b-card-text class="row align-items-center">
          <b-col v-if="item.image.length > 0">
            <img
              class="img-fluid rounded"
              style="max-width: 100px"
              :src="`${domain}${item.image[0].image_url}`"
              alt=""
            />
          </b-col>
          <b-col v-else
            ><img
              style="max-width: 100px"
              class="img-fluid"
              :src="require(`../assets/images/no-image.png`)"
              alt=""
          /></b-col>
          <b-col cols="12" md="2">{{ item.bio_name }}</b-col>
          <b-col cols="12" md="2">{{ item.bio_local_name }}</b-col>
          <b-col cols="12" md="2">{{ item.category.name }}</b-col>
          <b-col cols="12" md="2">{{ knowledgeDisplay(item.knowledge) }}</b-col>
          <b-col>
            <b-button
              class="my-auto mx-auto"
              pill
              style="background-color: #94b447; color: white"
              >อ่านต่อ
            </b-button>
          </b-col>
        </b-card-text>
      </b-card>
      <div class="d-flex mx-5 flex-row" style="flex-wrap: wrap">
        <button
          @click="queryListByCommunity(item.community_id)"
          class="badge-list-theme mt-2 mr-2"
          v-for="item in communityList"
          :key="item.community_id"
        >
          {{ item.name }} - {{ item.amount }}
        </button>
      </div>
      <div class="d-flex justify-content-center align-items-center my-4">
        <div class="mr-2">
          {{ pagination.page }} <span class="secondary-text">of</span>
          {{ pagination.pageCount }}
        </div>
        <div>
          <button
            @click="queryList(false)"
            :disabled="pagination.page === 1"
            :class="
              pagination.page === 1 ? 'paginate-button-none' : 'paginate-button'
            "
          >
            <span class="text-white" style="font-size: 1.5rem">&#8249;</span>
          </button>
          <button
            @click="queryList(true)"
            :disabled="pagination.page === pagination.pageStop"
            :class="
              pagination.page === pagination.pageStop
                ? 'paginate-button-none'
                : 'paginate-button'
            "
          >
            <span class="text-white" style="font-size: 1.5rem">&#8250;</span>
          </button>
        </div>
      </div>
    </div>
    <div v-else class="text-center text-muted">
      <h1>ไม่พบข้อมูลพันธ์พืช</h1>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Main_nav from "@/components/navbar";
import searchBar from "@/components/searchBar";
import { mapState } from "vuex";
import { domain } from "@/utils/Constants";
import Swal from "sweetalert2";

export default {
  name: "SearchResult",
  data() {
    return {
      text: "",
      domain: domain,
    };
  },
  components: {
    Main_nav,
    searchBar,
  },
  computed: {
    ...mapState({
      communityList: (state) => state.viewModule.community_list,
      pagination: (state) => state.viewModule.pagination,
      plantList: (state) => state.viewModule.plant_list,
      total_item_list: (state) => state.viewModule.total_item_list,
    }),
  },
  created() {
    Swal.fire({
      title: "ระบบกำลังทำงาน",
      html: "โปรดรอสักครู่...",
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
        this.$store
          .dispatch("viewModule/onGetPlantList", {
            knowledges_id: this.$route.query.knowledges_id
              ? this.$route.query.knowledges_id
              : null,
            categories_id: this.$route.query.categories_id
              ? this.$route.query.categories_id
              : null,
            community_id: this.$route.query.community_id
              ? this.$route.query.community_id
              : null,
            keyword: this.$route.query.keyword
              ? this.$route.query.keyword
              : null,
            page: 1,
          })
          .then((res) => {
            if (res == 200) {
              Swal.clickConfirm();
            } else {
              Swal.clickConfirm();
            }
          });
      },
    });
  },
  methods: {
    queryList(isNextPage) {
      console.log();
      let page = isNextPage
        ? this.pagination.page + 1
        : this.pagination.page - 1;

      Swal.fire({
        title: "ระบบกำลังทำงาน",
        html: "โปรดรอสักครู่...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch("viewModule/onGetPlantList", {
              knowledges_id: this.$route.query.knowledges_id
                ? this.$route.query.knowledges_id
                : null,
              categories_id: this.$route.query.categories_id
                ? this.$route.query.categories_id
                : null,
              community_id: this.$route.query.community_id
                ? this.$route.query.community_id
                : null,
              keyword: this.$route.query.keyword
                ? this.$route.query.keyword
                : null,
              page: page,
            })
            .then((res) => {
              if (res == 200) {
                Swal.clickConfirm();
              } else {
                Swal.clickConfirm();
              }
            });
        },
      });
    },
    queryListByCommunity(id) {
      this.$router.push({
        name: "SearchResult",
        query: {
          knowledges_id: this.$route.query.knowledges_id
            ? this.$route.query.knowledges_id
            : null,
          categories_id: this.$route.query.categories_id
            ? this.$route.query.categories_id
            : null,
          community_id: id,
          keyword: this.$route.query.keyword ? this.$route.query.keyword : null,
        },
      });
    },
    goBack() {
      const path = `/`;
      if (this.$route.path !== path) {
        this.$router.push(path);
      }
    },
    knowledgeDisplay(model) {
      if (model.length === 0) {
        return "";
      } else {
        if (model[0].level2) {
          if (model.length === 1) {
            return model[0].level2.knowledge.name;
          } else {
            return `${model[0].level2.knowledge.name}, ${model[1].level2.knowledge.name}, ...`;
          }
        } else {
          return "";
        }
      }
    },
    getDetail(id) {
      const path = `/BioDetai`;
      if (this.$route.path !== path) {
        this.$router.push({ name: "BioDetai", params: { id: id } });
      }
    },
  },
};
</script>
<style lang="scss">
.card_result {
  height: 69px;

  background: #ffffff;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
}
</style>
